import axios from "../javascript/custom-axios";
const RESOURCE_NAME = "admin/posts";
const USER_RESOURCE_NAME  = `/v1/posts`

export default {
  createPost(body) {
    return axios.post(`${RESOURCE_NAME}/create`, body);
  },

  deletePost(id){
    return axios.put(`${USER_RESOURCE_NAME}/delete/${id}`);   
  },

  updatePost(body) {
    return axios.put(`${USER_RESOURCE_NAME}/update`, body);
  },

  /**
   * Copy Post
   * @param {number} postId 
   * @returns 
   */
  copyPost(postId) {
    return axios.post(`${RESOURCE_NAME}/copy`, { PostId: postId });
  },

  /**
   * Bulk Update
   * @param {number[]} PostIds
   * @param {number} Status
   * @returns 
   */
  bulkUpdate(PostIds = [], Status = null) {
    return axios.post(`${RESOURCE_NAME}/bulk-update`, { PostIds, Status });
  },
};
